import React from 'react';
import { RootState } from 'types/state';
import AnnouncementBanner from 'components/AnnouncementBanner/AnnouncementBanner';
import { connect } from 'react-redux';
import { Announcements, fetchAnnouncementsRequest } from '@redux/modules/api/actions';
import { rootSelectors } from '@redux/modules/selectors';
import { getAnnouncementsResponse } from '@redux/modules/api/selectors';

interface Props {
  hasAnnouncementsFetchResponse: boolean
  fetchAnnouncements: () => void
  announcementList: Announcements
  currentSubsectionKey?: string
}

class AnnouncementBannerList extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  componentDidMount(): void {
    if (!this.props.hasAnnouncementsFetchResponse) {
      this.props.fetchAnnouncements();
    }
  }

  render() {
    return (
      <div>
        <ol className="usa-list-inline">
          {this.props.announcementList.announcements?.map((announcement: any) => (
            <AnnouncementBanner key={announcement.title} announcement={announcement} currentSubsectionKey={this.props?.currentSubsectionKey} />
          ))}
        </ol>
      </div>
    );
  }
}

AnnouncementBannerList.defaultProps = {
  currentSubsectionKey: '',

};

const mapStateToProps = (state: RootState) => {
  const announcementList = getAnnouncementsResponse(state) as Announcements || { announcements: [] };
  const hasAnnouncementsFetchResponse = rootSelectors.api.hasFetchResponses(state).announcements;
  return {
    announcementList,
    hasAnnouncementsFetchResponse
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchAnnouncements: () => dispatch(fetchAnnouncementsRequest()),
});

export { AnnouncementBannerList };
export default connect(mapStateToProps, mapDispatchToProps)(AnnouncementBannerList);
